import * as React from 'react';
import { Loader, TextField } from '@symphony-ui/uitoolkit-components';
import ApiServerURL from 'models/ApiServerUrl';
import ApiServerRequest from 'models/ApiServerRequest';
import DownloadContext from 'contexts/DownloadContext';
import PopupButtons from './PopupButtons';
const TickerPopUp = ({ hasOverride, initialValue, isDisabled, save, data }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [value, setValue] = React.useState(initialValue);
    const [esma, setEsma] = React.useState([]);
    const [loadingEsma, setLoadingEsma] = React.useState(false);
    const [errorEsma, setErrorEsma] = React.useState();
    const [issuer, setIssuer] = React.useState();
    const [loadingIssuer, setLoadingIssuer] = React.useState(false);
    const [errorIssuer, setErrorIssuer] = React.useState();
    const update = React.useMemo(() => {
        return data?.data?.issuer?.identifiers?.find(i => i.type === 'TICKER')?.value;
    }, [data?.data?.issuer?.identifiers]);
    const onChange = React.useCallback((event) => {
        const newValue = event.target.value;
        if (/[a-zA-Z]{0,6}/.exec(newValue) !== null) {
            setValue(newValue.toUpperCase());
        }
    }, []);
    React.useEffect(() => {
        const lei = data?.meta?.lei ?? data?.data?.issuer?.identifiers?.find(i => i.type === 'LEI')?.value;
        if (lei !== undefined) {
            const url = new ApiServerURL('/syndicate/meta/ticker');
            url.searchParams.append('lei', lei);
            const request = new ApiServerRequest(url);
            setLoadingEsma(true);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    setEsma(body);
                }
                catch (error) {
                    if (error instanceof Error) {
                        setErrorEsma("Error: " + error.message);
                    }
                }
                finally {
                    setLoadingEsma(false);
                }
            })();
        }
        else {
            setErrorEsma("No LEI known");
        }
    }, [apiFetchJson, data?.meta?.lei, data?.data?.issuer?.identifiers]);
    React.useEffect(() => {
        const companyId = data?.meta?.parties?.find(p => p.type === 'ISSUER')?.companyId;
        if (companyId !== undefined) {
            const url = new ApiServerURL('/admin/companies/find');
            url.searchParams.append('id', companyId);
            const request = new ApiServerRequest(url);
            setLoadingIssuer(true);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    setIssuer(body.tickers ?? []);
                }
                catch (error) {
                    if (error instanceof Error) {
                        setErrorIssuer("Error: " + error.message);
                    }
                }
                finally {
                    setLoadingIssuer(false);
                }
            })();
        }
        else {
            setErrorIssuer("No Issuer known");
        }
    }, [apiFetchJson, data?.meta?.parties]);
    const esmaContent = React.useMemo(() => {
        if (errorEsma !== undefined)
            return React.createElement("span", { className: 'co-error-message' }, errorEsma);
        if (loadingEsma)
            return (React.createElement(Loader, null));
        return (React.createElement("b", null, esma.join(", ")));
    }, [errorEsma, esma, loadingEsma]);
    const issuerContent = React.useMemo(() => {
        if (errorIssuer !== undefined)
            return React.createElement("span", { className: 'co-error-message' }, errorIssuer);
        if (loadingIssuer)
            return (React.createElement(Loader, null));
        return (React.createElement("b", null, (issuer ?? []).join(", ")));
    }, [errorIssuer, issuer, loadingIssuer]);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' } },
            React.createElement("div", null, "From Issuer:"),
            issuerContent),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' } },
            React.createElement("div", null, "From ESMA:"),
            esmaContent),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' } },
            React.createElement("div", null, "From Updates:"),
            React.createElement("b", null, update)),
        React.createElement(TextField, { disabled: isDisabled, onChange: onChange, value: value }),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { value: value, isDisabled: isDisabled, save: save, hasOverride: hasOverride })));
};
export default TickerPopUp;
